var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.i18nKey)?_c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.i18nKey})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }